const DOORS = {
  uk: [
    { id: '2', label: '2', selected: false },
    { id: '3', label: '3', selected: false },
    { id: '4', label: '4', selected: false },
    { id: '5', label: '5', selected: false },
    { id: '6', label: '6', selected: false },
  ],
  fr: [
    { id: '2', label: '2', selected: false },
    { id: '3', label: '3', selected: false },
    { id: '4', label: '4', selected: false },
    { id: '5', label: '5', selected: false },
    { id: '6', label: '6', selected: false },
  ],
  de: [
    { id: ['2', '3'], label: '2 bis 3', selected: false },
    { id: ['4', '5'], label: '4 bis 5', selected: false },
    { id: ['6', '7'], label: '6 bis 7', selected: false },
  ],
};

export { DOORS };
